import { sentidoAFavorDoVento } from '../vento'

/**
 * Onde o aluno pôs o caminhão receptor, em relação ao avariado e ao vento.
 *
 * O receptor chega com o motor ligado — uma fonte de ignição. A favor do
 * vento ele fica dentro do caminho dos vapores; contra o vento ou de lado,
 * fora. O setor "a favor do vento" aqui é ±60° em torno da direção para onde
 * o vento sopra (regra didática).
 */

export const MEIO_SETOR_A_FAVOR_GRAUS = 60
/** Comprimento de mangote do laboratório, m — didático, não de um fabricante. */
export const COMPRIMENTO_MANGOTE_M = 20

export type SetorVento = 'aFavor' | 'lateral' | 'contra'

export interface AvaliacaoPosicao {
  distanciaM: number
  setor: SetorVento
  /** Ângulo entre a direção avariado → receptor e o vento a favor, graus (0 = bem a favor). */
  anguloGraus: number
  alcancaMangote: boolean
}

export function avaliarPosicaoReceptor(
  avariado: readonly [number, number],
  receptor: readonly [number, number],
  direcaoVentoGraus: number,
  comprimentoMangoteM = COMPRIMENTO_MANGOTE_M,
): AvaliacaoPosicao {
  const dx = receptor[0] - avariado[0]
  const dz = receptor[1] - avariado[1]
  const distanciaM = Math.hypot(dx, dz)
  const [vx, vz] = sentidoAFavorDoVento(direcaoVentoGraus)
  const cos = distanciaM === 0 ? 1 : (dx * vx + dz * vz) / distanciaM
  const anguloGraus = (Math.acos(Math.min(1, Math.max(-1, cos))) * 180) / Math.PI
  const setor: SetorVento = anguloGraus <= MEIO_SETOR_A_FAVOR_GRAUS ? 'aFavor' : anguloGraus >= 180 - MEIO_SETOR_A_FAVOR_GRAUS ? 'contra' : 'lateral'
  return { distanciaM, setor, anguloGraus, alcancaMangote: distanciaM <= comprimentoMangoteM }
}
